'use client'

import dynamic from 'next/dynamic'
import { SkeletonItem } from 'components/skeleton-item'

export const MembersCountClient = dynamic(
  () => import('./members-count').then(module => module.MembersCount),
  {
    ssr: false,
    loading: () => <SkeletonItem className="h-[20px] w-[160px] rounded-full my-2" />,
  },
)
